const state = {
  cardNo: '',
  status: {
    ryb: '',
    wqcly: ''
  }
}

const mutations = {
  SET_CARDNO(state, obj) {
    state.cardNo = obj.cardNo
  },
  SET_OIL(state, obj) {
    state.status.ryb = obj.ryb
    state.status.wqcly = obj.wqcly
  },

  RESET(state) {
    state.cardNo = ''
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
